import React, {  useState } from 'react'
import './login.scss';
import { Link} from 'react-router-dom';
import axios from 'axios';


const  Login = ({setuser}) => {
  const  handleLogin = async(e)=>{
    e.preventDefault();
    try{
      const {data} = await axios.post("/api/login",{email,password},{withCredentials:true});
      setuser({data,isAuthenticated:true});
    }
    catch(err){
      alert(err.message)
    }
    }
const  [email, setemail] = useState('')
const  [password, setpassword] = useState('')
     return (
      <div className="login-page">
        <div className="wrapper">
          <h1>Sign in</h1>
          <form onSubmit={handleLogin}>
          <input type="text" placeholder='Enter your Email' name='email' value={email} onChange={e=>setemail(e.currentTarget.value)}/>  
          <input type="password" placeholder='Enter your Password' name='password' value={password} onChange={e=>setpassword(e.currentTarget.value)} />  
          <input type="submit" value='Login' className='login-btn' />
          </form>
          <div className="register-options">
            <p>Don't have an account <Link to={'/register'}>sign up here</Link></p>
          </div>
      </div>
        </div>
    
  )
     }

export default Login